/**
 * Classe pra componetizar o ModalForm
 *
 * @author Adalto Junior DATE: 15/03/2013
 *
 */

Monet.Form = Monet.Form || {};

// TODO: refatorar o construtor da classe, receber um objeto somente
Monet.Form.Modal = function (selector, options, callbacks, scopeBlock) {

    if (typeof (selector) !== "undefined") {
        this.selector = selector;
    } else {
        this.selector = null;
    }

    if (typeof (options) !== "undefined" && options !== null) {
        this.options = options;
    } else {
        this.options = {
            width: 685,
            height: 480
        };
    }

    if (typeof (callbacks) !== "undefined") {
        this.callbacks = callbacks;
    } else {
        this.callbacks = null;
    }

    if (typeof (scopeBlock) !== "undefined") {
        this.scopeBlock = scopeBlock;
    } else {
        this.scopeBlock = selector;
    }

    this.showModalForm = function () {

        var popup = [],
            popupNotExists = true,
            parentContainer = null,
            error = null;

        if (this.selector !== null) {

            try {

                if (this.callbacks !== null && typeof (this.callbacks.onBeforeShowModalForm) !== "undefined") {

                    this.callbacks.onBeforeShowModalForm();

                }

                parentContainer = document.querySelector(this.selector);

                if (parentContainer !== null) {

                    popup = parentContainer.getElementsByClassName("popupFormContainer");
                    popupNotExists = popup.length === 0;

                    if (popupNotExists) {

                        parentContainer.appendChild(this.createBtnCloseModalWindow());
                        parentContainer.appendChild(this.createContentModalWindow());

                        $(this.scopeBlock).block({
                            message: null
                        });

                        this.addEventListenner();
                    }
                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "No modal window to show.");
                error.console();

            }

            if (this.callbacks !== null && typeof (this.callbacks.onAfterShowModalForm) !== "undefined") {

                this.callbacks.onAfterShowModalForm();

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                "No selector to show modal window.");
            error.console();

        }

    };

    this.createBtnCloseModalWindow = function () {

        var closeModalWindow = document.createElement("div");

        closeModalWindow.setAttribute("class", "closeModalWindow");

        var width = this.options.width;
        var height = this.options.height;

        var closeMarginLeft = (width / 2) - 10;
        var closeTop = ((height / 2) * -1) - 10;

        closeModalWindow.style.position = "absolute";
        closeModalWindow.style.marginLeft = closeMarginLeft + "px";
        closeModalWindow.style.marginTop = closeTop + "px";
        closeModalWindow.style.top = "50%";

        return closeModalWindow;

    };

    this.createContentModalWindow = function () {

        const contentModalWindow = document.createElement("div");

        try {
            const { width, height, className = '' } = this.options;

            contentModalWindow.setAttribute("class", `popupFormContainer ${className}`);

            const contentMarginLeft = (width / 2) * -1;
            const contentTop = (height / 2) * -1;

            contentModalWindow.style.width = width + "px";
            contentModalWindow.style.height = height + "px";

            contentModalWindow.style.position = "absolute";
            contentModalWindow.style.marginLeft = contentMarginLeft + "px";
            contentModalWindow.style.marginTop = contentTop + "px";
            contentModalWindow.style.top = "50%";

        } catch (e) {
          new Monet.Exception
            .ReturnError(this, "No create content modal window.")
            .console();
        }

        return contentModalWindow;

    };

    this.addEventListenner = function () {

        var that = this,
            error = null,
            selectorBtnClose = this.selector + " .closeModalWindow",
            btnCloseModalWindow = document.querySelector(selectorBtnClose);

        try {

            btnCloseModalWindow.onclick = function () {

                that.closeModalWindow();

            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No event listenners to modal window.");
            error.console();

        }

    };

    this.closeModalWindow = function () {

        var divParent = null,
            contentModalWindow = null,
            closeModalWindow = null,
            contentModalWindowSelector = "",
            closeModalWindowSelector = "";

        try {

            contentModalWindowSelector = this.selector + " .popupFormContainer";
            closeModalWindowSelector = this.selector + " .closeModalWindow";

            divParent = document.querySelector(this.selector);
            contentModalWindow = document.querySelector(contentModalWindowSelector);
            closeModalWindow = document.querySelector(closeModalWindowSelector);

            if (this.callbacks !== null && typeof (this.callbacks.onBeforeCloseModalForm) !== "undefined") {
                this.callbacks.onBeforeCloseModalForm();
            }

            divParent.removeChild(contentModalWindow);
            divParent.removeChild(closeModalWindow);

            $(this.scopeBlock).unblock();

            if (this.callbacks !== null && typeof (this.callbacks.onAfterCloseModalForm) !== "undefined") {
                this.callbacks.onAfterCloseModalForm();
            }

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this,
                "No modal window to remove.");
            error.console();
        }

    };

    this.toggleLoadingInModalBtn = function(buttonsSectionSelector) {
        const buttonSection = buttonsSectionSelector || ".formButtons";
        const selectorId = this.selector ? `${this.selector} ` : '';
        const formButtonsModal = document.querySelector(selectorId + buttonSection);
        if(formButtonsModal) {
            var formButtonsModalList = Array.from(formButtonsModal.childNodes);
            for (var btn of formButtonsModalList) {
                if(!btn.name.includes('exit')) {
                    btn.classList && btn.classList.toggle("loader-spinner");
                }
                btn.disabled = !btn.disabled;
            }
        }
    }
};
